const rankings = [
  { rank: 1, title: '盗墓笔记之重启', category: '冒险悬疑', hot: '985万', trend: 'up', change: '+2' },
  { rank: 2, title: '长相思第二季', category: '古装玄幻', hot: '872万', trend: 'up', change: '+5' },
  { rank: 3, title: '繁花', category: '都市剧情', hot: '756万', trend: 'stable', change: '0' },
  { rank: 4, title: '玫瑰的故事', category: '都市爱情', hot: '689万', trend: 'up', change: '+3' },
  { rank: 5, title: '甄嬛传', category: '古装宫斗', hot: '621万', trend: 'stable', change: '0' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影视排行
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全网实时热度排行，看看大家都在追什么
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl overflow-hidden">
            {rankings.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                  i < rankings.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap flex-shrink-0">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-xs flex-shrink-0">
                  <span className="text-foreground-500 flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500"></i>
                    {item.hot}
                  </span>
                  <span className={`flex items-center gap-1 font-medium ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
                  }`}>
                    {item.trend === 'up' ? (
                      <i className="ri-arrow-up-line"></i>
                    ) : (
                      <i className="ri-arrow-right-line"></i>
                    )}
                    {item.change}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}